var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-medium well m-auto mt-8 external-plugins" },
    [
      _vm.plugins.length > 0
        ? _c(
            "ul",
            _vm._l(_vm.sortedPlugins, function(plugin, indexPlugin) {
              return _c(
                "li",
                {
                  key: indexPlugin,
                  staticClass: "dinlineb span_2 gutters valign-top acenter"
                },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "block p-4 b-1-black-hover cpointer br w-160 m-auto black",
                      attrs: { href: plugin.url, onClick: plugin.call }
                    },
                    [
                      plugin.isSlsyIcon
                        ? _c("CompassIcon", {
                            staticClass: "compassIcon",
                            attrs: {
                              customFile: _vm.pathSlsyIcon(plugin.iconSvg),
                              customIcon: plugin.iconSvg
                            }
                          })
                        : _c("SaasIcon", {
                            attrs: {
                              height: "40",
                              width: "41",
                              icon: plugin.iconSvg
                            }
                          }),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "gray-100 fs-3 semibold m-0 mt-2" },
                        [_vm._v(_vm._s(plugin.label))]
                      )
                    ],
                    1
                  )
                ]
              )
            }),
            0
          )
        : _c("div", { staticClass: "placeholder" }, [
            _c("p", [
              _vm._v(_vm._s(_vm.$l10n.__("Vous n'avez pas de module externe")))
            ])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }